import type { FilterOption } from '@frontend/libs/types/shop'
import type React from 'react'

import { Checkbox, CheckboxGroup } from '@nextui-org/react'

export interface CheckBoxGroupFilterProps {
  onChange?: (value: string[]) => void
  options?: FilterOption[]
  value?: string[]
}

export function CheckBoxGroupFilter({
  onChange,
  options,
  value,
}: Readonly<CheckBoxGroupFilterProps>): React.JSX.Element {
  return (
    <div>
      <div className="w-full px-1 py-2">
        <CheckboxGroup
          classNames={{
            wrapper: 'gap-4',
          }}
          onChange={onChange}
          size="lg"
          value={value}
        >
          {options?.map((option) => (
            <Checkbox key={option.id} value={option.slug}>
              {option.name}
            </Checkbox>
          ))}
        </CheckboxGroup>
      </div>
    </div>
  )
}

export default CheckBoxGroupFilter
